"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.373 3a.7.7 0 0 1 .7.7v10.733l5.908-4.643a.7.7 0 1 1 .865 1.1l-4.468 3.512 4.572 5.448a.7.7 0 0 1-1.073.9l-4.6-5.482-1.204.945V20.3a.7.7 0 1 1-1.4 0V3.7a.7.7 0 0 1 .7-.7m9.974 6.64a.7.7 0 0 1 .7.7v1.395q.24-.146.523-.29c1.033-.525 2.515-1.002 4.187-.686a.7.7 0 1 1-.26 1.375c-1.261-.237-2.42.116-3.293.56a7 7 0 0 0-1.157.737V20.3a.7.7 0 1 1-1.4 0v-9.96a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencyNorwegianKroneIcon24.js.map